import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import {
  postServerDataWithPath,
  getServerDataWithTypes,
} from "../../../action/common_action";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import Drag from "./dragNdDrop";
import moment from "moment";
import useModel from "../common/useModel";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import ReactAudioPlayer from "react-audio-player";
import { ToastContainer, toast } from "react-toastify";
import ExcelPopup from "./ExcelPopup";
import { history } from "../../../history/history";
import AudioRequestDetails from "./AudioRequestDetails";
import AudioBriefPopup from "./AudioBriefPopup";
import ApproveModel from "./approveModel";
import RejectModel from "./rejectModel";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import MultipleaudioList from "../../common/audiolist";
import { ShowStations } from "../../campaign/ShowStations";
import ViewStationsModal from "./ViewStationsModal";

const audiomanagment = (props) => {
  const [audioStateArr] = useState(["Uploaded", "Approved", "Audio Rejected"]);
  const [audiolist, handleAudioList] = useState([]);
  const [audiolength, handleAudiolength] = useState(undefined);
  const [audioCost, handleAudioCost] = useState(undefined);
  const [audioUrl, handleAudioUrl] = useState(undefined);
  const [audioBrief, handleAudioBrief] = useState(undefined);
  const [audioDuration, handleAudioDuration] = useState(undefined);
  const [audioSize, handleAudioSize] = useState(undefined);
  const [audioStatus, handleAudioStatus] = useState(undefined);
  const [approvedBy, handleApprovedBy] = useState(undefined);
  const [approvedOn, handleApprovedOn] = useState(undefined);
  const [audioTotalCost, handleAudioTotalCost] = useState(undefined);
  const [audioOption, handleAudioOption] = useState(undefined);
  const [audioStatustype, handleaudioStatustype] = useState(undefined);
  const [uploadAudio, handleUploadAudio] = useState(undefined);
  const [campaignDetails, handleCampaignDetails] = useState({});
  const [rejetcremarks, handlerejetcremarks] = useState([]);
  const [showUploadAudio, handleShowUploadAudio] = useState(false);
  const [showAudioBrief, handleShowAudioBrief] = useState(false);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const [showMultipleAudio, setShowMultipleAudio] = useState(false);
  const [showApproveAudio, setShowHideApproveAudio] = useState(false);
  const [showRejectAudio, setShowHideRejectAudio] = useState(false);
  const [multipleAudios, setMultipleAudios] = useState([]);
  const [user_email, handleUserEmail] = useState("");
  const [campaignId, handleCampaignId] = useState("");
  const [station, handleStation] = useState(undefined);
  const campaignName = useRef(undefined);
  const campaignIdField = useRef(undefined);
  const audioFileName = useRef(undefined);
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);


  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const userEmail = useRef(undefined);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));

  useEffect(() => {
    getAudiolist(0);
  }, []);


  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };

  const toggle = () => {
    setShowHideApproveAudio(!showApproveAudio);
  };

  const rejectToggle = () => {
    setShowHideRejectAudio(!showRejectAudio);
  };
const hideMultipleAudio = ()=>{
  setShowMultipleAudio(false);
}
  const showMultipleAudios = (e) => {
    setShowMultipleAudio(true);
    setMultipleAudios(e);
  };
  //Get getAudiolist
  const getAudiolist = async (skip) => {
    console.log("Audoi management");
    let paramsConstrct;
    handleSkip(skip);
    try {
      if (
        adminInfo &&
        adminInfo.role &&
        (adminInfo.role === "salesUser" || adminInfo.role === "auditAdmin")
      ) {
        paramsConstrct = {
          skip,
          audioStatus: audioStatustype,
          fileName: audioFileName.current.value,
          name: campaignName.current.value,
          _id: campaignIdField.current.value,
          startDate,
          endDate,
          cluster: adminInfo.role === "admin" ? undefined : adminInfo.cluster,
          sallerId: adminInfo.email,
        };
      }
      if (adminInfo && adminInfo.role && adminInfo.role === "stationAdmin") {
        paramsConstrct = {
          skip,
          audioStatus: audioStatustype,
          fileName: audioFileName.current.value,
          name: campaignName.current.value,
          _id: campaignIdField.current.value,
          startDate,
          endDate,
          station: adminInfo.station,
          sallerId: adminInfo.email,
        };
      } else {
        paramsConstrct = {
          skip,
          audioStatus: audioStatustype,
          fileName: audioFileName.current.value,
          name: campaignName.current.value,
          _id: campaignIdField.current.value,
          startDate,
          endDate,
          cluster: adminInfo.role === "admin" ? undefined : adminInfo.cluster,
        };
      }
      const data = await Axios.get(endPoints.getPreviousAudio, {
        //  const data = await Axios.get(endPoints.getAudiolist,{
        params: paramsConstrct,
      });
      const result = data.data.data.data;
      console.log("audioaudioStatusStatus", result);
      if (result) {
        handleCount(data.data.data.count);
        handleAudioList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openPopup = (event, rejetcremarkss) => {
    console.log(event.target.value);
    console.log(rejetcremarkss.status);
    if (
      rejetcremarkss &&
      rejetcremarkss.status &&
      rejetcremarkss.status != "New" &&
      event.target.value === "New"
    ) {
      console.log("Error");
      toast.warn("Status cannot be set to New", {
        position: toast.POSITION.TOP_CENTER,

        hideProgressBar: false,
        toastId: "1",
      });
    } else {
      rejetcremarkss.status = event.target.value;
      rejetcremarkss.showAddRemarks = true;
      rejetcremarkss.showListRemarks = true;
      handlerejetcremarks(rejetcremarkss);
      toggle();
    }
  };

  const openRemarksPopup = (rejetcremarkss) => {
    console.log(rejetcremarkss);
    rejetcremarkss.showAddRemarks = false;
    rejetcremarkss.showListRemarks = true;
    rejetcremarkss.remarks = rejetcremarkss.remarks.reverse();
    handlerejetcremarks(rejetcremarkss);
    toggle();
  };

  

  //Update Status for contact us entry
  const updateStatus = async (params) => {
    console.log(params);
    try {
      const data = await Axios.put(endPoints.updateRemarksAudioreject, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Redirect to route bassed on path
  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const getUploadedFile = (event) => {
    this.setState({
      uploadAudio: event.target,
    });
  };

  const showHideUploadAudio = (campaign) => {
    handleCampaignDetails(campaign);
    toggleUploadAudio();
  };

  const toggleUploadAudio = () => {
    handleShowUploadAudio(!showUploadAudio);
  };

  const showHideAudioBrief = (campaign) => {
    handleCampaignDetails(campaign);
    toggleAudioBrief();
  };

  const toggleAudioBrief = () => {
    handleShowAudioBrief(!showAudioBrief);
  };

  const callSearch = (e) => {
    e.preventDefault();
    getAudiolist(0);
  };

  //Set audio status
  const setAudioStatus = async (event, campaign) => {
    let { value } = event.target;
    handleCampaignDetails(campaign);
    let data = {
      _id: campaign._id,
      updateObj: {
        status: value === "New" ? "Pending" : value,
        audioStatus: value,
        audiostatuschangedby: adminInfo.email,
      },
    };
    if (value === "Approved") {
      // data.userEmail = campaign.userEmail;
      // await props.updateCampaign(endPoints.updateCampaign, data, '/admin/campaign');
      toggle();
    } else if (value === "Audio Rejected") {
      if (campaign.audioStatus === "Approved") {
        alert("Cannot Reject previously approved audio");
      } else {
        // openRejectPopup(campaign, event);
        rejectToggle();
      }
    }
  };

  //Show rejected popup
  const openRejectPopup = (Campaign, e) => {
    let { bigFmAudio } = Campaign;
    if (bigFmAudio === "true") {
      return;
    }
    handleUserEmail(Campaign.userEmail ? Campaign.userEmail : "");
    handleCampaignId(Campaign._id ? Campaign._id : "");
    handleStation(campaign.station ? campaign.station : "");
    rejectToggle();
  };

  //Return the t
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>

          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Audio Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Audio List
                </span>
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>
                    </td>
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>
                    </td>
                    {(localStorage.getItem("adminRole") &&
                      localStorage.getItem("adminRole") === "audioAdmin") ||
                      (localStorage.getItem("adminRole") === "admin" && (
                        <td>
                          <div className="drop">
                            <select
                              className="packageType drop-down-icon"
                              onChange={(event) =>
                                handleaudioStatustype(event.target.value)
                              }
                            >
                              <option value=""> Choose Audio Status</option>
                              <option value="Uploaded"> Uploaded </option>
                              <option value="Approved">Approved </option>
                              <option value="Audio Rejected">
                                Audio Rejected
                              </option>
                            </select>
                          </div>
                        </td>
                      ))}
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={audioFileName}
                          placeholder="Audio File Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Campaign Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={campaignIdField}
                          placeholder="Campaign Id"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="print_btn">
                        <button onClick={callSearch}>Search</button>
                      </span>
                    </td>
                    <td>
                      <span className="print_btn mrgLft10px">
                        <button onClick={clearSearch}>Clear</button>
                      </span>
                    </td>
                    {/*<td>*/}
                    {/*    <span className="print_btn mrgLft10px">*/}
                    {/*        <button> Audio Download</button>*/}
                    {/*    </span>*/}
                    {/*</td>*/}
                  </tr>
                </tbody>
              </table>
            </form>

            <div
              className={
                audiolist.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    {/*<th>Created Date</th>                                     */}
                    {/*<th>Created By</th>                                     */}
                    <th>Campaign Id</th>
                    <th>Campaign Name</th>
                    <th>Start Date</th>
                    <th>Uploaded Date</th>
                    <th>Uploaded By</th>
                    <th>Sales User Id</th>
                    <th>Station</th>
                    <th>FileName</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Status Changed By</th>
                    <th>Audio Brief</th>
                    <th>Audio Length</th>
                    <th>Play Audio</th>
                    <th>Remarks</th>
                    <th>Actions</th>
                    {/* <th>Upload Audio</th>  */}
                    {/* <th>Reject Remarks</th>    */}
                  </tr>
                </thead>
                <tbody>
                  {audiolist.map((a, i) => (
                    <tr key={i}>
                      {/*<td>{a.createdBy}</td>*/}
                      <td>{a._id}</td>
                      <td>{a.name}</td>
                      <td>{moment(a.startDate).format("DD/MM/YYYY")}</td>
                      <td>{moment(a.updatedAt).format("DD/MM/YYYY")}</td>
                      {a.bigFmAudio && a.bigFmAudio == "true" && <td>BigFm</td>}
                      {a.bigFmAudio && a.bigFmAudio == "false" && (
                        <td>
                          <p>Customer</p>
                          <p>
                            {a.userDetails.length > 0 && a.userDetails[0].name}
                          </p>
                        </td>
                      )}
                      <td>{a.sallerId}</td>
                      <td>{a.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  debugger;
                                  handleshowstationlist(true);
                                  handleCurrentStations(a.station.split(","));
                                }}
                              >
                                Multiple ({a.station.split(",").length})
                              </a>
                            ) : (
                              a.station
                            )}</td>
                      <td>{a.fileName}</td>
                      <td>{a.audioDuration && a.audioDuration.toFixed(0)}</td>

                      {/* <td>*/}
                      {/* <span className="tooltip-reject view-tooltip">*/}
                      {/*<img src="/assets/images/audieye.png"  onClick= {showHideExcelPopup}/>*/}
                      {/*</span>*/}
                      {/*</td>*/}

                      <td>
                        {adminInfo.role !== "financeAdmin" &&
                          (adminInfo.role !== "salesUser" ||
                            (adminInfo.role === "salesUser" &&
                              a.sallerId &&
                              adminInfo.email.trim() === a.sallerId.trim())) &&
                          (adminInfo.role !== "auditAdmin" ||
                            (adminInfo.role === "auditAdmin" &&
                              a.sallerId &&
                              adminInfo.email.trim() ===
                                a.sallerId.trim())) && (
                            <select
                              value={
                                a.audioStatus === "Pending"
                                  ? "New"
                                  : a.audioStatus
                              }
                              onChange={(event) => setAudioStatus(event, a)}
                              className={
                                a.audioStatus == "Requested"
                                  ? "status_select new"
                                  : a.audioStatus === "Audio Rejected"
                                  ? "status_select audio_approved"
                                  : "status_select ro_approved"
                              }
                              disabled={a.bigFmAudio === "true"}
                            >
                              {audioStateArr.map((audioState, index) => (
                                <option key={index}>{audioState}</option>
                              ))}
                            </select>
                          )}
                        {adminInfo.role === "financeAdmin" && a.audioStatus}
                        {((adminInfo.role === "salesUser" &&
                          (!a.sallerId ||
                            adminInfo.email.trim() !== a.sallerId.trim())) ||
                          (adminInfo.role === "auditAdmin" &&
                            (!a.sallerId ||
                              adminInfo.email.trim() !== a.sallerId.trim()))) &&
                          (!a.audioStatus || a.audioStatus === "Pending"
                            ? "New"
                            : a.audioStatus)}
                      </td>
                      <td>{a.audiostatuschangedby}</td>
                      <td className="txt-cntr">
                        <a>
                          <span className="tooltip-reject view-tooltip">
                            {/*<img src="/assets/images/upload.png" className="upload-png reject-png" onClick={() => history.push('/admin/audioadminmanagment/UploadAudiolist',{a})}>*/}
                            <img
                              src="/assets/images/eye.png"
                              className="uploadaudiofile"
                              onClick={() => showHideAudioBrief(a)}
                            ></img>
                            <span>View</span>
                          </span>
                        </a>
                      </td>
                      <td>{a.audioLength}</td>
                      <td style={{ textAlign: "center", cursor:"pointer" }}>
                        {a.audioUrl && (
                          <ReactAudioPlayer src={a.audioUrl} controls />
                        )}
                        {a.audioUrls && a.audioUrls.length == 1 && (
                          <ReactAudioPlayer src={a.audioUrls[0].awsurl} controls />
                        )}
                        
                        <span
                          onClick={(e) => {
                            showMultipleAudios(a.audioUrls);
                          }}
                        >
                          {a.audioUrls &&
                            a.audioUrls.length > 0 &&
                            a.audioUrls.length}
                        </span>
                      </td>
                      <td className="txt-cntr">
                        <span>{a.reason}</span>
                      </td>

                      {a.bigFmAudio &&
                        a.bigFmAudio === "true" &&
                        a.audioStatus === "Audio Rejected" &&
                        (adminInfo.role == "audioAdmin" ||
                          adminInfo.role == "admin") && (
                          <td className="txt-cntr">
                            <a>
                              <span className="tooltip-reject view-tooltip">
                                <img
                                  src="/assets/images/upload_audio.png"
                                  className="uploadaudiofile"
                                  onClick={() => showHideUploadAudio(a)}
                                ></img>
                                <span>Upload</span>
                              </span>
                            </a>
                          </td>
                        )}
                      {((a.bigFmAudio && a.bigFmAudio === "false") ||
                        a.audioStatus === "Approved") && <td> - </td>}
                      <td>
                        {localStorage.getItem("adminRole") &&
                          localStorage.getItem("adminRole") === "audioAdmin" &&
                          a.status === "Audio Approved" &&
                          "Audio Rejected" && (
                            <span className="status-select ro_approved">
                              {a.status}
                            </span>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationTable" />
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getAudiolist} totalRecords={count} />
              )}
            </div>
            {audiolist.length === 0 ? <NoData /> : null}
          </section>
        </div>
      </div>
      {showExcelPopup && <ExcelPopup hideExcelPopup={showHideExcelPopup} />}

      {showUploadAudio && (
        <AudioRequestDetails
          hideUploadAudio={toggleUploadAudio}
          campaignDetails={campaignDetails}
        />
      )}

      {showAudioBrief && (
        <AudioBriefPopup
          hideAudioBrief={toggleAudioBrief}
          campaignDetails={campaignDetails}
        />
      )}

      <ApproveModel
        isShowing={showApproveAudio}
        hide={toggle}
        user_email={campaignDetails.userEmail}
        campaignId={campaignDetails._id}
        changedby={adminInfo.email}
        station={campaignDetails.station}
      />

      <RejectModel
        isRejectShowing={showRejectAudio}
        hide={rejectToggle}
        user_email={campaignDetails.userEmail}
        campaignId={campaignDetails._id}
        changedby={adminInfo.email}
        station={campaignDetails.station}
      />
      {showMultipleAudio && (
        <MultipleaudioList
          isNewShowing={showMultipleAudio}
          hide={hideMultipleAudio}
          audios={multipleAudios}
        />
      )}
      {showstationlist && (
                <ViewStationsModal
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};
export default connect(null, mapDispatchToProps)(audiomanagment);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/audiomanagment.js